import React, { useState } from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import '../../styles/EvalueRequest.css';

function EvalueRequest() {
  const [isFormVisible, setIsFormVisible] = useState(false); // State to manage form visibility
  const [formData, setFormData] = useState({
    address: '',
    mobile: '',
    floorArea: '',
  });
  const [loading, setLoading] = useState(false); // Loading state
  const [isFormValid, setIsFormValid] = useState(false); // Track form validity

  const toggleForm = () => {
    setIsFormVisible(!isFormVisible); // Toggle form visibility
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedFormData = {
      ...formData,
      [name]: value,
    };
    setFormData(updatedFormData);

    // Check if all fields are filled
    const isValid = Object.values(updatedFormData).every((field) => field.trim() !== '');
    setIsFormValid(isValid);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid) {
      alert('Please fill in all fields before submitting.');
      return;
    }

    setLoading(true); // Show loading screen

    const scriptUrl = 'https://script.google.com/macros/s/AKfycbydAMk1C12dP4qxiS8xOjBSOoscHLr0V6exMeUnRRdqndcjuvnN8ZMduN9BC_TBF3XX_g/exec';
    try {
      // Submit the form data
      await fetch(scriptUrl, {
        method: 'POST',
        body: JSON.stringify({ ...formData, formType: 'Evalue' }),
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'no-cors', // Add this line to bypass CORS issues
      });

      // On success
      alert('Form submitted successfully. We will contact you shortly.');
      setFormData({ address: '', mobile: '', floorArea: '' }); // Clear form
      setIsFormVisible(false); // Hide form
      setIsFormValid(false); // Reset form validity
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className='section text-center'>
      <div className='evalueRequest'>
        <h1>How much is my home worth?</h1>
        <p>
          E-Value offers homeowners and investors swift, unbiased property valuations.
          Leveraging advanced AI and machine learning, we deliver precise assessments
          in moments, enhancing accuracy and efficiency in the real estate market.
        </p>
        <button className='buttonType1' onClick={toggleForm}>
          {isFormVisible ? <ExpandLessIcon style={{ color: 'black' }} /> : 'Submit your request'}
        </button>
        {/* Loading Screen */}
        {loading && (
          <div className='loadingOverlay'>
            <div className='loadingSpinner'></div>
            <p>Submitting your request...</p>
          </div>
        )}

        {/* Foldable Form */}
        {isFormVisible && (
          <div className='formContainer'>
            <form onSubmit={handleSubmit}>
              <div className='formGroup'>
                <label htmlFor='address'>Address</label>
                <input
                  type='text'
                  id='address'
                  name='address'
                  value={formData.address}
                  onChange={handleChange}
                  placeholder='Please key in your address with postal code'
                  required
                />
              </div>
              <div className='formGroup'>
                <label htmlFor='mobile'>Mobile Number</label>
                <input
                  type='tel'
                  id='mobile'
                  name='mobile'
                  value={formData.mobile}
                  onChange={handleChange}
                  placeholder='Please key in your mobile number'
                  required
                />
              </div>
              <div className='formGroup'>
                <label htmlFor='floorArea'>Floor Area (sqft)</label>
                <input
                  type='number'
                  id='floorArea'
                  name='floorArea'
                  value={formData.floorArea}
                  onChange={handleChange}
                  placeholder='Floor Area (sqft)'
                  required
                />
              </div>
              <button type='submit' className='buttonType1' disabled={!isFormValid}>
                Submit
              </button>
            </form>
          </div>
        )}
      </div>
    </section>
  );
}

export default EvalueRequest;